import React from 'react';
import { Strip } from '../../Models/Article';
import { ArticleContent as BaseArticleContent } from '../../Devon/Components/ArticleContent/ArticleContent';
import { SpacerStrip } from '../../Devon/Components/ArticleContent/SpacerStrip';
import { HtmlContentBlockStrip } from './HtmlContentBlockStrip';
import { ReaderStrip } from './ReaderStrip';
import { WheelStrip } from './WheelStrip';
import { UpcomingReleasesWheelStrip } from './UpcomingReleasesWheelStrip';
import { ProductSeriesGridStrip } from './ProductSeriesGridStrip';
import { BrowseGenreListStrip } from './BrowseGenreListStrip';
import { ChapterWheelStrip } from './ChapterWheelStrip';
import { SpotlightSeriesStrip } from './SpotlightSeriesStrip';
import { NewsWheelStrip } from './NewsWheelStrip';
import { ContinueReadingGridStrip } from './ContinueReadingGridStrip';
import { ReaderBenefitsStrip } from './ReaderBenefitsStrip';
import { NewsHeaderOrHeroStrip } from './NewsHeaderOrHeroStrip';
import GroupedItemCollectionStrip from './GroupedItemCollectionStrip';
import ContactUsStrip from './ContactUsStrip';
import NewsLetterSignUpStrip from './NewsLetterSignUpStrip';
import SupportCenterPageLinksTemp from './SupportCenterPageLinksTemp';
import './ArticleContent.scss';

const components: Record<string, React.ComponentType<{ strip: Strip}>> = {
    'news-header': NewsHeaderOrHeroStrip,
    'html-content-block': HtmlContentBlockStrip,
    'reader': ReaderStrip,
    'product-series-wheel': WheelStrip,
    'product-series-grid': ProductSeriesGridStrip,
    'upcoming-releases-wheel': UpcomingReleasesWheelStrip,
    'browse-genre-list': BrowseGenreListStrip,
    'chapter-wheel': ChapterWheelStrip,
    'spotlight-series': SpotlightSeriesStrip,
    'news-wheel': NewsWheelStrip,
    'continue-reading-grid': ContinueReadingGridStrip,
    'reader-benefits': ReaderBenefitsStrip,
    'grouped-item-collection': GroupedItemCollectionStrip,
    'contact-form': ContactUsStrip,
    'newsletter-signup': NewsLetterSignUpStrip,
    'support-center-page-links': SupportCenterPageLinksTemp,
    'spacer': SpacerStrip,
};

interface ArticleContentProps {
    id: number;
    style: string;
    strips: Strip[];
}

export function ArticleContent({ id, style, strips }: ArticleContentProps) {
    return <BaseArticleContent renderStrip={renderStrip} id={id} style={style} strips={strips} />;
}

function renderStrip(strip: Strip) {
    const Component = components[strip.container];
    return Component  ? <Component strip={strip} /> : null;
}
